import {
  isTemplateZapId,
  isTemplateTableId,
  isTemplateInterfaceProjectId,
  isTemplateChatbotId,
  isTemplateAgentId,
} from "./isTemplateId";
import { type AssetType } from "../types";

interface Params {
  assetId?: string;
  assetType?: AssetType;
}

/**
 * INTERNAL UTILITY - DO NOT USE DIRECTLY
 *
 * Determines if a node is a draft node based on its asset properties.
 * Since draft nodes now have real UUIDs, we check the asset ids to determine draft status.
 *
 * @internal
 * Use isDraftNotTemplateNodeAtomFamily() or isDraftOrTemplateNodeAtomFamily() instead.
 */
export function isDraftNode({ assetId, assetType }: Params): boolean {
  // If there's no assetId, it's definitely NOT a draft since we use asset ids to determine if a node is draft
  if (!assetId) {
    return false;
  }

  // Check if the assetId indicates it's still a draft based on asset type
  switch (assetType) {
    case "zap":
      return isTemplateZapId(assetId);
    case "table":
      return isTemplateTableId(assetId);
    case "interface":
      return isTemplateInterfaceProjectId(assetId);
    case "chatbot":
      return isTemplateChatbotId(assetId);
    case "agent":
      return isTemplateAgentId(assetId);
    default:
      // If we don't know the asset type, default to false
      return false;
  }
}
